// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TestingTypeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class TestingTypeApiClient extends BaseCRUDApiClient<TestingTypeDto> {
  baseUrl = this.config.apiEndpoint + '/testing-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
